// extracted by css-extract-rspack-plugin
var _1 = "QriIb6IdbZs4khCD";
var _2 = "ekRKK0z298yUtS0b";
export { _1 as "container", _2 as "containerFluid" }
// extracted by css-extract-rspack-plugin
var _1 = "QriIb6IdbZs4khCD";
var _2 = "ekRKK0z298yUtS0b";
export { _1 as "container", _2 as "containerFluid" }
